const Fieldsets = () => (
  <fieldset>
    <legend>I love fieldsets!</legend>
    <fieldset>
      <legend>Three reasons fieldsets so great?</legend>
      <fieldset>
        <legend>1. Free, interesting border!</legend>
        By default it comes with a border, and you can give it a border, to wrap more lines around it. Neat!
      </fieldset>
      <fieldset>
        <legend>2. The title is clearly separated from the explanation</legend>
        But what am I even reading? It's in the top, clearly! the topic is literally part of the container-border!
      </fieldset>
      <fieldset>
        <legend>3. Much Ontology!</legend>
        The ontology is built in, no need to worry your little noggin on it~
      </fieldset>
    </fieldset>
  </fieldset>
);

export default Fieldsets;
